export function textFieldPostalCode({ hideCity } = { hideCity: false }) {
  const postalCode = document.querySelector('.TextField--postalCode');
  const city = document.querySelector('.TextField--city');
  const cityWrapper = city.closest('.floating-label-wrapper');

  if(hideCity) {
    cityWrapper.parentNode.classList.add('hidden');
  }

  if(postalCode && city){
    postalCode.addEventListener('change', async () => {
      if(postalCode.value.length === 5){
        const response = await fetch(`https://geo.api.gouv.fr/communes?codePostal=${postalCode.value}&fields=nom,population`);
        const data = await response.json();

        data.sort((a, b) => b.population - a.population);

        if(data?.length){
          city.value = data[0].nom;
        }

        if(hideCity) {
          cityWrapper.parentNode.classList.remove('hidden');
        }
      }
    });
  }
}
